import type { DisplayPublic } from '../api';
import { ChannelChrome } from './ChannelChrome';

const PLACEHOLDER = [
  { rank: 1, name: 'A. Stone', team: 'SPR', stat: 'PTS', value: '—' },
  { rank: 2, name: 'J. Reyes', team: 'SPR', stat: 'PTS', value: '—' },
  { rank: 3, name: 'S. Park', team: 'SPR', stat: 'PTS', value: '—' },
  { rank: 4, name: 'M. Davis', team: 'RVS', stat: 'PTS', value: '—' },
  { rank: 5, name: 'T. Lee', team: 'RVS', stat: 'PTS', value: '—' },
];

export function StatsBoardChannel({
  display,
  connected,
  onUnpair,
}: {
  display: DisplayPublic;
  connected: boolean;
  onUnpair: () => void;
}) {
  return (
    <ChannelChrome display={display} connected={connected} onUnpair={onUnpair}>
      <div className="mx-auto w-full max-w-5xl px-12 py-12">
        <div className="text-xs uppercase tracking-[0.4em] text-white/40">
          Season leaders
        </div>
        <h1 className="mt-3 text-6xl font-bold tracking-tight">Top Performers</h1>
        <div className="mt-12 space-y-3">
          {PLACEHOLDER.map((p) => (
            <div
              key={p.rank}
              className="flex items-center gap-6 rounded-xl border border-white/5 bg-white/[0.03] px-6 py-4"
            >
              <div className="w-12 font-mono text-4xl font-bold text-white/30">
                {p.rank}
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-2xl font-semibold">{p.name}</div>
                <div className="font-mono text-xs uppercase tracking-wider text-white/40">
                  {p.team}
                </div>
              </div>
              <div className="text-right">
                <div className="font-mono text-3xl font-bold">{p.value}</div>
                <div className="font-mono text-xs uppercase tracking-wider text-white/40">
                  {p.stat}
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-8 text-sm text-white/30">
          Stats board · live values arrive once games are scored. Placeholder roster shown.
        </p>
      </div>
    </ChannelChrome>
  );
}
